module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai153-315f7bbcae4ece23de7e7a3153274d4d.jpg";